import firebase from '@/firebase'
import { groupByFamily } from '@/utils/modelVersions.js'
const db = firebase.db
const functions = firebase.functions

// Debug logging utility for Vuex modules
const debugLog = (...args) => {
  if (typeof window !== 'undefined' && window.location) {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('debug') === 'true') {
      console.log(...args)
    }
  }
}

// Utility function to chunk arrays into smaller pieces
const chunkArray = (array, chunkSize = 10) => {
  const chunks = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}

// Tableau 3
const colors = [
  '#A6CEE3',
  '#B2DF8A',
  '#FB9A99',
  '#FDBF6F',
  '#CAB2D6',
  '#B15928',
  '#1F78B4',
  '#33A02C',
  '#E31A1C',
  '#FF7F00',
  '#6A3D9A',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F717F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C49C94',
  '#F7B6D2',
  '#A6CEE3',
  '#B2DF8A',
  '#FB9A99',
  '#FDBF6F',
  '#CAB2D6',
  '#B15928',
  '#1F78B4',
  '#33A02C',
  '#E31A1C',
  '#FF7F00',
  '#6A3D9A',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F717F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C49C94',
  '#F7B6D2',
  '#A6CEE3',
  '#B2DF8A',
  '#FB9A99',
  '#FDBF6F',
  '#CAB2D6',
  '#B15928',
  '#1F78B4',
  '#33A02C',
  '#E31A1C',
  '#FF7F00',
  '#6A3D9A',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F717F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C49C94',
  '#F7B6D2',
  '#A6CEE3',
  '#B2DF8A',
  '#FB9A99',
  '#FDBF6F',
  '#CAB2D6',
  '#B15928',
  '#1F78B4',
  '#33A02C',
  '#E31A1C',
  '#FF7F00',
  '#6A3D9A',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F717F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C49C94',
  '#F7B6D2',
  '#A6CEE3',
  '#B2DF8A',
  '#FB9A99',
  '#FDBF6F',
  '#CAB2D6',
  '#B15928',
  '#1F78B4',
  '#33A02C',
  '#E31A1C',
  '#FF7F00',
  '#6A3D9A',
  '#1F77B4',
  '#FF7F0E',
  '#2CA02C',
  '#D62728',
  '#9467BD',
  '#8C564B',
  '#E377C2',
  '#7F717F',
  '#BCBD22',
  '#17BECF',
  '#AEC7E8',
  '#FFBB78',
  '#98DF8A',
  '#FF9896',
  '#C49C94',
  '#F7B6D2'
]

const state = {
  clients: [],
  groupClients: [],
  currentClient: null,
  currentClientObject: null,
  currentClientDataFiles: [],
  currentClientDataFilesLoaded: false,
  currentClientDataBriefs: [],
  currentClientStages: [],
  // Messages of every Review stage's feedback chat, oldest first
  currentClientStageFeedback: [],
  basePrimaryColor: null,
  clientsInitialized: false,
  recentModels: [],
  recentModelsLoading: false,
  recentModelsHasMore: false,
  recentModelsLastVisible: null,
  allRecentModels: [],
  allRecentModelsLoading: false,
  allRecentModelsHasMore: false,
  allRecentModelsLastVisible: null,
  accessibleRecentModels: [],
  accessibleRecentModelsLoading: false,
  accessibleRecentModelsHasMore: false,
  accessibleRecentModelsLastVisible: null,
  userCreatedModels: [],
  userCreatedModelsLoading: false,
  userCreatedModelsHasMore: false,
  userCreatedModelsLastVisible: null,
  allRecentUploads: [],
  allRecentUploadsLoading: false,
  allRecentUploadsHasMore: false,
  allRecentUploadsLastVisible: null,
  userRecentUploads: [],
  userRecentUploadsLoading: false,
  userRecentUploadsHasMore: false,
  userRecentUploadsLastVisible: null,
  allRecentStageActivity: [],
  allRecentStageActivityLoading: false,
  allRecentStageActivityHasMore: false,
  allRecentStageActivityLastVisible: null,
  userRecentStageActivity: [],
  userRecentStageActivityLoading: false,
  userRecentStageActivityHasMore: false,
  userRecentStageActivityLastVisible: null,
  accessibleRecentEkrms: [],
  accessibleRecentEkrmsLoading: false,
  accessibleRecentEkrmsHasMore: false,
  accessibleRecentEkrmsLastVisible: null,
  userCreatedEkrms: [],
  userCreatedEkrmsLoading: false,
  userCreatedEkrmsHasMore: false,
  userCreatedEkrmsLastVisible: null,
  // Unsubscribe functions for Firestore listeners to prevent memory leaks
  unsubscribeClients: null,
  unsubscribeGroupClients: null,
  unsubscribeAllClients: null,
  unsubscribeClientStages: null,
  unsubscribeClientStageFeedback: null,
  unsubscribeClientDataFiles: null,
  unsubscribeClientDataBriefs: null,
  // Array to hold multiple chunk unsubscribers for loadClientsRealtime
  unsubscribeClientsChunks: []
}

const getters = {
  clients: state => {
    return state.clients
  },
  groupClients: state => {
    return state.groupClients
  },
  currentClient: state => {
    return state.currentClient
  },
  currentClientObject: state => {
    return state.currentClientObject
  },
  // Ad-Hoc version families among the models this user can see (direct and group access). Without access
  // to the latest version of a family, the latest one they can see is their current version.
  modelVersionFamilies: state => {
    const seen = new Set()
    const models = state.clients.concat(state.groupClients).filter(client => {
      if (client.type !== 'mmm' || seen.has(client.id)) {
        return false
      }
      seen.add(client.id)
      return true
    })
    return groupByFamily(models)
  },
  currentClientDataFiles: state => {
    return state.currentClientDataFiles
  },
  currentClientDataFilesLoaded: state => {
    return state.currentClientDataFilesLoaded
  },
  currentClientDataBriefs: state => {
    return state.currentClientDataBriefs
  },
  currentClientStages: state => {
    return state.currentClientStages
  },
  currentClientStageFeedback: state => {
    return state.currentClientStageFeedback
  },
  basePrimaryColor: state => {
    return state.basePrimaryColor
  },
  clientsInitialized: state => {
    return state.clientsInitialized
  },
  recentModels: state => {
    return state.recentModels
  },
  recentModelsLoading: state => {
    return state.recentModelsLoading
  },
  allRecentModels: state => {
    return state.allRecentModels
  },
  allRecentModelsLoading: state => {
    return state.allRecentModelsLoading
  },
  accessibleRecentModels: state => {
    return state.accessibleRecentModels
  },
  accessibleRecentModelsLoading: state => {
    return state.accessibleRecentModelsLoading
  },
  userCreatedModels: state => {
    return state.userCreatedModels
  },
  userCreatedModelsLoading: state => {
    return state.userCreatedModelsLoading
  },
  allRecentUploads: state => {
    return state.allRecentUploads
  },
  allRecentUploadsLoading: state => {
    return state.allRecentUploadsLoading
  },
  userRecentUploads: state => {
    return state.userRecentUploads
  },
  userRecentUploadsLoading: state => {
    return state.userRecentUploadsLoading
  },
  allRecentStageActivity: state => {
    return state.allRecentStageActivity
  },
  allRecentStageActivityLoading: state => {
    return state.allRecentStageActivityLoading
  },
  userRecentStageActivity: state => {
    return state.userRecentStageActivity
  },
  userRecentStageActivityLoading: state => {
    return state.userRecentStageActivityLoading
  },
  accessibleRecentEkrms: state => {
    return state.accessibleRecentEkrms
  },
  accessibleRecentEkrmsLoading: state => {
    return state.accessibleRecentEkrmsLoading
  },
  userCreatedEkrms: state => {
    return state.userCreatedEkrms
  },
  userCreatedEkrmsLoading: state => {
    return state.userCreatedEkrmsLoading
  }
}

const actions = {
  // Cleanup all Firestore listeners to prevent memory leaks
  cleanupListeners (context) {
    if (context.state.unsubscribeClients) {
      context.state.unsubscribeClients()
      context.commit('setUnsubscribeClients', null)
    }
    if (context.state.unsubscribeGroupClients) {
      context.state.unsubscribeGroupClients()
      context.commit('setUnsubscribeGroupClients', null)
    }
    if (context.state.unsubscribeAllClients) {
      context.state.unsubscribeAllClients()
      context.commit('setUnsubscribeAllClients', null)
    }
    if (context.state.unsubscribeClientStages) {
      context.state.unsubscribeClientStages()
      context.commit('setUnsubscribeClientStages', null)
    }
    if (context.state.unsubscribeClientStageFeedback) {
      context.state.unsubscribeClientStageFeedback()
      context.commit('setUnsubscribeClientStageFeedback', null)
    }
    if (context.state.unsubscribeClientDataFiles) {
      context.state.unsubscribeClientDataFiles()
      context.commit('setUnsubscribeClientDataFiles', null)
    }
    if (context.state.unsubscribeClientDataBriefs) {
      context.state.unsubscribeClientDataBriefs()
      context.commit('setUnsubscribeClientDataBriefs', null)
    }
    // Cleanup all chunk listeners
    if (context.state.unsubscribeClientsChunks && context.state.unsubscribeClientsChunks.length > 0) {
      context.state.unsubscribeClientsChunks.forEach(unsub => unsub())
      context.commit('setUnsubscribeClientsChunks', [])
    }
  },
  saveSaturationAlternativeValues (context, payload) {
    return new Promise((resolve, reject) => {
      // Convert string values to numbers where possible
      const processedPayload = Object.keys(payload).reduce((acc, key) => {
        const value = payload[key]
        // Check if value is a string that represents a number
        if (typeof value === 'string' && value.trim() !== '' && !isNaN(value) && !isNaN(parseFloat(value))) {
          acc[key] = parseFloat(value)
        } else {
          acc[key] = value
        }
        return acc
      }, {})
      db.collection('clients').doc(context.state.currentClient).update({
        saturationAlternativeUnitValues: processedPayload
      }).then(() => {
        resolve()
      }).catch(function (error) {
        console.error('Error setting saturation alternative values: ', error)
        reject(error)
      })
    })
  },
  updateModelStageStatus (context, payload) {
    return new Promise((resolve, reject) => {
      const updateModelProcessStageStatus = functions.httpsCallable('updateModelProcessStageStatus')
      updateModelProcessStageStatus({
        modelId: payload.modelId,
        stageIndex: payload.stageIndex
      })
        .then((result) => {
          console.log(result.data)
          resolve()
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },
  // Posts a message in a Review stage's feedback chat, or edits the user's own when messageId is given
  saveStageFeedback (context, payload) {
    const saveStageFeedback = functions.httpsCallable('saveStageFeedback')
    return saveStageFeedback({
      modelId: context.state.currentClient,
      stageName: payload.stageName,
      text: payload.text,
      reportVersion: payload.reportVersion,
      messageId: payload.messageId || null
    }).then(result => result.data)
  },
  // Only the author can delete a message; it stays in the chat as deleted
  deleteStageFeedback (context, payload) {
    const deleteStageFeedback = functions.httpsCallable('deleteStageFeedback')
    return deleteStageFeedback({
      modelId: context.state.currentClient,
      messageId: payload.messageId
    }).then(result => result.data)
  },
  // The summary comes back as a JSON string and is not kept in the store: it can be large
  getDataCheckSummary (context, payload) {
    const getDataCheckSummary = functions.httpsCallable('userData-getDataCheckSummary', { timeout: 540000 })
    return getDataCheckSummary({
      clientId: context.state.currentClient,
      fileName: payload.fileName,
      forceRebuild: !!payload.forceRebuild
    }).then(result => result.data)
  },
  setDataCheckApproval (context, payload) {
    const setDataCheckApproval = functions.httpsCallable('userData-setDataCheckApproval')
    return setDataCheckApproval({
      clientId: context.state.currentClient,
      fileName: payload.fileName,
      approved: payload.approved
    }).then(result => result.data)
  },
  logStageFileUpload (context, payload) {
    return new Promise((resolve, reject) => {
      const logStageFileUpload = functions.httpsCallable('logStageFileUpload')
      logStageFileUpload({
        modelId: payload.modelId,
        stageName: payload.stageName
      })
        .then((result) => {
          console.log(result.data)
          resolve()
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },
  addDataFile (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('clients').doc(payload.client).collection('data_files').doc(payload.dataFile.name).set({
        ...payload.dataFile
      }).then(() => {
        resolve()
      }).catch(function (error) {
        console.error('Error adding dataFile: ', error)
        reject(error)
      })
    })
  },
  addDataBrief (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('clients').doc(payload.client).collection('data_briefs').doc(payload.dataBrief.name).set({
        ...payload.dataBrief
      }).then(() => {
        resolve()
      }).catch(function (error) {
        console.error('Error adding dataBrief: ', error)
        reject(error)
      })
    })
  },
  updateDataFile (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('clients').doc(context.state.currentClient).collection('data_files').doc(payload.name).update({
        ...payload.dataFile
      }).then(() => {
        resolve()
      }).catch(function (error) {
        console.error('Error updating dataFile: ', error)
        reject(error)
      })
    })
  },
  updateDataBrief (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('clients').doc(context.state.currentClient).collection('data_briefs').doc(payload.name).update({
        ...payload.dataBrief
      }).then(() => {
        resolve()
      }).catch(function (error) {
        console.error('Error updating dataBrief: ', error)
        reject(error)
      })
    })
  },
  loadClientDataFiles (context, client) {
    if (client) {
      // Cleanup existing listener before creating a new one
      if (context.state.unsubscribeClientDataFiles) {
        context.state.unsubscribeClientDataFiles()
      }
      // Until the first snapshot arrives, the files of the previous model must not show
      context.commit('setCurrentClientDataFiles', { dataFiles: [], loaded: false })
      const unsubscribe = db.collection('clients').doc(client).collection('data_files').onSnapshot(snapshot => {
        let dataFiles = []
        snapshot.forEach(doc => {
          const data = doc.data()
          dataFiles.push(data)
        })
        context.commit('setCurrentClientDataFiles', {
          dataFiles: dataFiles
        })
      })
      context.commit('setUnsubscribeClientDataFiles', unsubscribe)
    }
  },
  loadClientDataBriefs (context, client) {
    if (client) {
      // Cleanup existing listener before creating a new one
      if (context.state.unsubscribeClientDataBriefs) {
        context.state.unsubscribeClientDataBriefs()
      }
      const unsubscribe = db.collection('clients').doc(client).collection('data_briefs').onSnapshot(snapshot => {
        let dataBriefs = []
        snapshot.forEach(doc => {
          const data = doc.data()
          dataBriefs.push(data)
        })
        context.commit('setCurrentClientDataBriefs', {
          dataBriefs: dataBriefs
        })
      })
      context.commit('setUnsubscribeClientDataBriefs', unsubscribe)
    }
  },
  loadNewClient (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('clients').doc(payload.id).get().then(snapshot => {
        // A model that is gone, or that the user may not read, used to leave the caller waiting.
        if (!snapshot.exists) {
          reject(new Error('Model not found'))
          return
        }
        let data = snapshot.data()
        // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
        // Parse on-demand in components that actually need it (e.g., ModelReport view)
        context.commit('updateClients', {
          ...data,
          id: snapshot.id,
          colors: colors
        })
        resolve()
      }).catch(reject)
    })
  },
  async loadGroupClients (context, payload) {
    if (payload.groups) {
      let clients = []
      await db.collection('groups').doc('data').collection('users').doc(payload.user).collection('models').get().then(async snapshot => {
        await snapshot.forEach(async doc => {
          const data = doc.data()
          if (data.groupCount > 0) {
            await db.collection('clients').doc(doc.id).get().then(client => {
              if (client.exists) {
                const data = client.data()
                // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
                // Parse on-demand in components that actually need it (e.g., ModelReport view)
                clients.push({
                  ...data,
                  id: client.id,
                  colors: colors
                })
              }
            })
          }
        })
      })
      context.commit('setGroupClients', {
        clients: clients
      })
      if (clients.length > 0 && localStorage.currentClientId) {
        context.commit('setCurrentClient', localStorage.currentClientId)
      }
    }
  },
  async loadGroupClientsRealtime (context, payload) {
    debugLog('DEBUG: loadGroupClientsRealtime called with payload:', payload)
    if (payload.groups && payload.user) {
      // Cleanup existing listener before creating a new one
      if (context.state.unsubscribeGroupClients) {
        context.state.unsubscribeGroupClients()
      }
      // First, get the model IDs this user has access to through groups
      const unsubscribe = await db.collection('groups').doc('data').collection('users').doc(payload.user).collection('models').onSnapshot(modelsSnapshot => {
        debugLog('DEBUG: loadGroupClientsRealtime - models onSnapshot triggered, documents count:', modelsSnapshot.docs.length)
        const clientIds = []
        modelsSnapshot.forEach(doc => {
          const data = doc.data()
          debugLog('DEBUG: loadGroupClientsRealtime - checking model:', doc.id, 'groupCount:', data.groupCount)
          if (data.groupCount > 0) {
            clientIds.push(doc.id)
          }
        })
        debugLog('DEBUG: loadGroupClientsRealtime - extracted client IDs from groups:', clientIds)

        if (clientIds.length > 0) {
          // For group access, fetch clients individually instead of using collection query
          // This avoids permission issues when users don't have direct collection read access
          debugLog('DEBUG: loadGroupClientsRealtime - fetching clients individually to avoid permission issues')
          const clients = []
          const fetchPromises = clientIds.map(clientId =>
            db.collection('clients').doc(clientId).get()
              .then(doc => {
                if (doc.exists) {
                  let data = doc.data()
                  // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
                  // Parse on-demand in components that actually need it (e.g., ModelReport view)
                  clients.push({
                    ...data,
                    id: doc.id,
                    colors: colors
                  })
                  debugLog('DEBUG: loadGroupClientsRealtime - successfully loaded client:', doc.id)
                } else {
                  debugLog('DEBUG: loadGroupClientsRealtime - client document does not exist:', clientId)
                }
              })
              .catch(error => {
                // Log individual document errors but don't fail the whole operation
                console.error('ERROR: loadGroupClientsRealtime - failed to load client:', clientId, error.message)
              })
          )

          // Wait for all client fetches to complete
          Promise.all(fetchPromises).then(() => {
            context.commit('setGroupClients', {
              clients: clients
            })
            if (clients.length > 0 && localStorage.currentClientId) {
              const clientExists = clients.some(client => client.id === localStorage.currentClientId)
              if (clientExists) {
                context.commit('setCurrentClient', localStorage.currentClientId)
              } else {
                delete localStorage.currentClientId
              }
            }
            context.commit('setClientsInitialized', true)
            debugLog('DEBUG: loadGroupClientsRealtime - successfully loaded group clients:', clients.map(c => c.id))
          }).catch(error => {
            console.error('ERROR: loadGroupClientsRealtime - Promise.all failed:', error)
            console.error('ERROR: Falling back to regular loadGroupClients')
            context.dispatch('loadGroupClients', payload)
          })
        } else {
          // No clients accessible, set empty array
          debugLog('DEBUG: loadGroupClientsRealtime - no clients found with groupCount > 0')
          context.commit('setGroupClients', {
            clients: []
          })
          context.commit('setClientsInitialized', true)
        }
      }, error => {
        console.error('ERROR: loadGroupClientsRealtime models onSnapshot failed:', error)
        console.error('ERROR: User:', payload.user)
        console.error('ERROR: Error code:', error.code)
        console.error('ERROR: Error message:', error.message)

        if (error.code === 'permission-denied') {
          console.error('ERROR: Permission denied for group models - falling back to regular loadGroupClients')
          context.dispatch('loadGroupClients', payload)
        } else if (error.code === 'unavailable') {
          console.error('ERROR: Firestore unavailable - retrying in 2 seconds...')
          setTimeout(() => {
            context.dispatch('loadGroupClientsRealtime', payload)
          }, 2000)
        } else {
          console.error('ERROR: Unknown error - check Firestore rules for /groups/data/users/{uid}/models read permissions')
        }
      })
      context.commit('setUnsubscribeGroupClients', unsubscribe)
    }
  },
  async loadClients (context, payload) {
    if (payload.clients) {
      let clients = []
      for (const client of payload.clients) {
        await client.get().then((snapshot) => {
          // TODO: Handle the cases where a client is added or removed while a viewer user is online
          if (snapshot.exists) {
            const data = snapshot.data()
            // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
            // Parse on-demand in components that actually need it (e.g., ModelReport view)
            clients.push({
              ...data,
              id: snapshot.id,
              colors: colors
            })
          }
        })
      }
      context.commit('setClients', {
        clients: clients
      })
      if (clients.length > 0 && localStorage.currentClientId) {
        context.commit('setCurrentClient', localStorage.currentClientId)
      }
    }
  },
  async loadClientsRealtime (context, payload) {
    debugLog('DEBUG: loadClientsRealtime called with payload:', payload)
    if (payload.clients && payload.clients.length > 0) {
      // Cleanup existing listeners before creating new ones
      if (context.state.unsubscribeClients) {
        context.state.unsubscribeClients()
        context.commit('setUnsubscribeClients', null)
      }
      // Cleanup all chunk listeners if they exist
      if (context.state.unsubscribeClientsChunks && context.state.unsubscribeClientsChunks.length > 0) {
        context.state.unsubscribeClientsChunks.forEach(unsub => unsub())
        context.commit('setUnsubscribeClientsChunks', [])
      }
      // Extract client IDs from the client references
      const clientIds = []
      for (const clientRef of payload.clients) {
        clientIds.push(clientRef.id)
      }
      debugLog('DEBUG: loadClientsRealtime - extracted client IDs:', clientIds)

      // Use chunking strategy for arrays with more than 10 client IDs to avoid Firebase security rule issues
      if (clientIds.length > 10) {
        debugLog('DEBUG: loadClientsRealtime - using chunking strategy for', clientIds.length, 'client IDs')

        // Split client IDs into chunks of 8 to stay well under Firebase limits
        const clientChunks = chunkArray(clientIds, 8)
        const allClients = []
        const unsubscribeFunctions = []
        let chunksCompleted = 0
        let hasError = false

        const processChunkResults = () => {
          if (chunksCompleted === clientChunks.length && !hasError) {
            // All chunks completed successfully, update the store
            context.commit('setClients', {
              clients: allClients
            })
            if (allClients.length > 0 && localStorage.currentClientId) {
              const clientExists = allClients.some(client => client.id === localStorage.currentClientId)
              if (clientExists) {
                context.commit('setCurrentClient', localStorage.currentClientId)
              } else {
                delete localStorage.currentClientId
              }
            }
            context.commit('setClientsInitialized', true)
            debugLog('DEBUG: loadClientsRealtime - successfully loaded all chunked clients:', allClients.map(c => c.id))
          }
        }

        // Set up listeners for each chunk
        clientChunks.forEach((chunk, chunkIndex) => {
          debugLog(`DEBUG: loadClientsRealtime - setting up listener for chunk ${chunkIndex + 1}/${clientChunks.length}:`, chunk)

          const unsubscribe = db.collection('clients')
            .where(firebase.firestore.FieldPath.documentId(), 'in', chunk)
            .onSnapshot(snapshot => {
              debugLog(`DEBUG: loadClientsRealtime - chunk ${chunkIndex + 1} onSnapshot triggered, documents count:`, snapshot.docs.length)

              // Process document changes for this chunk
              snapshot.docChanges().forEach(function (change) {
                if (change.type === 'removed' && change.doc.id === context.state.currentClient) {
                  console.log('Removed currently selected client')
                }
              })

              // Update clients from this chunk
              const chunkClients = []
              snapshot.forEach(doc => {
                let data = doc.data()
                // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
                // Parse on-demand in components that actually need it (e.g., ModelReport view)
                chunkClients.push({
                  ...data,
                  id: doc.id,
                  colors: colors
                })
              })

              // Replace clients from this chunk in the allClients array
              // Remove existing clients from this chunk first
              chunk.forEach(clientId => {
                const existingIndex = allClients.findIndex(client => client.id === clientId)
                if (existingIndex !== -1) {
                  allClients.splice(existingIndex, 1)
                }
              })
              // Add new clients from this chunk
              allClients.push(...chunkClients)

              chunksCompleted = Math.max(chunksCompleted, chunkIndex + 1)
              processChunkResults()
            }, error => {
              console.error(`ERROR: loadClientsRealtime chunk ${chunkIndex + 1} onSnapshot failed:`, error)
              console.error(`ERROR: Chunk ${chunkIndex + 1} client IDs that failed to load:`, chunk)
              console.error('ERROR: Error code:', error.code)
              console.error('ERROR: Error message:', error.message)

              hasError = true
              // Clean up all listeners
              unsubscribeFunctions.forEach(unsub => unsub())

              if (error.code === 'permission-denied') {
                console.error('ERROR: Permission denied - falling back to regular loadClients')
                context.dispatch('loadClients', { clients: payload.clients })
              } else if (error.code === 'unavailable') {
                console.error('ERROR: Firestore unavailable - retrying in 2 seconds...')
                setTimeout(() => {
                  context.dispatch('loadClientsRealtime', payload)
                }, 2000)
              } else {
                console.error('ERROR: Unknown error - check Firestore rules for /clients/{clientId} read permissions')
              }
            })

          unsubscribeFunctions.push(unsubscribe)
        })
        // Store all chunk unsubscribe functions in state for later cleanup
        context.commit('setUnsubscribeClientsChunks', unsubscribeFunctions)
      } else {
        // For smaller arrays (<=10), use the original single query approach
        debugLog('DEBUG: loadClientsRealtime - using single query for', clientIds.length, 'client IDs')

        const unsubscribe = await db.collection('clients')
          .where(firebase.firestore.FieldPath.documentId(), 'in', clientIds)
          .onSnapshot(snapshot => {
            debugLog('DEBUG: loadClientsRealtime - onSnapshot triggered, documents count:', snapshot.docs.length)
            snapshot.docChanges().forEach(function (change) {
              if (change.type === 'removed' && change.doc.id === context.state.currentClient) {
                console.log('Removed currently selected client')
              }
            })
            var clients = []
            snapshot.forEach(doc => {
              let data = doc.data()
              // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
              // Parse on-demand in components that actually need it (e.g., ModelReport view)
              clients.push({
                ...data,
                id: doc.id,
                colors: colors
              })
            })
            context.commit('setClients', {
              clients: clients
            })
            if (clients.length > 0 && localStorage.currentClientId) {
              const clientExists = clients.some(client => client.id === localStorage.currentClientId)
              if (clientExists) {
                context.commit('setCurrentClient', localStorage.currentClientId)
              } else {
                delete localStorage.currentClientId
              }
            }
            context.commit('setClientsInitialized', true)
            debugLog('DEBUG: loadClientsRealtime - successfully loaded clients:', clients.map(c => c.id))
          }, error => {
            console.error('ERROR: loadClientsRealtime onSnapshot failed:', error)
            console.error('ERROR: Client IDs that failed to load:', clientIds)
            console.error('ERROR: Error code:', error.code)
            console.error('ERROR: Error message:', error.message)

            if (error.code === 'permission-denied') {
              console.error('ERROR: Permission denied - falling back to regular loadClients')
              context.dispatch('loadClients', { clients: payload.clients })
            } else if (error.code === 'unavailable') {
              console.error('ERROR: Firestore unavailable - retrying in 2 seconds...')
              setTimeout(() => {
                context.dispatch('loadClientsRealtime', payload)
              }, 2000)
            } else {
              console.error('ERROR: Unknown error - check Firestore rules for /clients/{clientId} read permissions')
            }
          })
        context.commit('setUnsubscribeClients', unsubscribe)
      }
    }
  },
  async loadAllClients (context) {
    // Cleanup existing listener before creating a new one
    if (context.state.unsubscribeAllClients) {
      context.state.unsubscribeAllClients()
    }
    const unsubscribe = await db.collection('clients').orderBy('name', 'asc').onSnapshot(snapshot => {
      /* console.log('loadAllClients')
      console.log(snapshot) */
      snapshot.docChanges().forEach(function (change) {
        /* console.log('Change:')
        console.log(change.type) */
        if (change.type === 'removed' && change.doc.id === context.state.currentClient) {
          console.log('Removed currently selected client')
        }
      })
      var clients = []
      snapshot.forEach(doc => {
        let data = doc.data()
        // MEMORY OPTIMIZATION: Keep model_report as string to avoid Vue reactivity overhead
        // Parse on-demand in components that actually need it (e.g., ModelReport view)
        clients.push({
          ...data,
          id: doc.id,
          colors: colors
        })
      })
      context.commit('setClients', {
        clients: clients
      })
      if (clients.length > 0 && localStorage.currentClientId) {
        // Check if the stored client ID exists in the loaded clients
        const clientExists = clients.some(client => client.id === localStorage.currentClientId)
        if (clientExists) {
          context.commit('setCurrentClient', localStorage.currentClientId)
        } else {
          // Clear the stored client ID if it no longer exists or user lost access
          delete localStorage.currentClientId
        }
      }
      context.commit('setClientsInitialized', true)
    }, error => {
      console.error('[ERROR] loadAllClients onSnapshot failed:', error)
      console.error('[ERROR] Error code:', error.code)
      console.error('[ERROR] Error message:', error.message)
    })
    context.commit('setUnsubscribeAllClients', unsubscribe)
  },
  async loadClientStages (context, payload) {
    // Cleanup existing listener before creating a new one
    if (context.state.unsubscribeClientStages) {
      context.state.unsubscribeClientStages()
    }
    const unsubscribe = await db.collection('clients').doc(payload.client).onSnapshot(snapshot => {
      let stages = snapshot.data().stages
      context.commit('setCurrentClientStages', stages)
    })
    context.commit('setUnsubscribeClientStages', unsubscribe)
  },
  loadClientStageFeedback (context, payload) {
    if (context.state.unsubscribeClientStageFeedback) {
      context.state.unsubscribeClientStageFeedback()
    }
    // Emptied first so another model's messages don't show until the first snapshot arrives
    context.commit('setCurrentClientStageFeedback', [])
    const unsubscribe = db.collection('clients').doc(payload.client).collection('stage_feedback').orderBy('createdAt').onSnapshot(snapshot => {
      context.commit('setCurrentClientStageFeedback', snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
    }, error => {
      console.error('Error loading stage feedback:', error)
    })
    context.commit('setUnsubscribeClientStageFeedback', unsubscribe)
  },
  setCurrentClient (context, client) {
    context.commit('setCurrentClient', client)
    // Track model access for recent models feature
    if (client && context.rootState.auth && context.rootState.auth.uid) {
      context.dispatch('trackModelAccess', {
        clientId: typeof client === 'object' ? client.code : client,
        userId: context.rootState.auth.uid
      })
    }
  },
  trackModelAccess (context, payload) {
    if (payload.clientId && payload.userId) {
      // Find client name from clients or groupClients
      let clientName = ''
      const clientObj = context.state.clients.find(c => c.id === payload.clientId) ||
                        context.state.groupClients.find(c => c.id === payload.clientId)
      if (clientObj) {
        clientName = clientObj.name
      }
      // Update or create recent model access record
      db.collection('users').doc(payload.userId).collection('recent_models').doc(payload.clientId).set({
        clientId: payload.clientId,
        clientName: clientName,
        lastAccessed: firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true }).catch(error => {
        console.error('Error tracking model access:', error)
      })
    }
  },
  loadRecentModels (context, params = {}) {
    context.commit('setRecentModelsLoading', true)
    const getRecentModels = functions.httpsCallable('userMetrics-getUserRecentModels')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getRecentModels(requestParams)
      .then((result) => {
        const models = result.data.items.map(model => ({
          ...model,
          lastAccessed: model.lastAccessed ? new Date(model.lastAccessed) : null
        }))
        const payload = {
          models: models,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendRecentModels', payload)
        } else {
          context.commit('setRecentModels', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading recent models:', error)
        context.commit('setRecentModelsLoading', false)
      })
  },
  loadAllRecentModels (context, params = {}) {
    context.commit('setAllRecentModelsLoading', true)
    const getRecentModels = functions.httpsCallable('userMetrics-getRecentModels')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getRecentModels(requestParams)
      .then((result) => {
        const models = result.data.items.map(model => ({
          ...model,
          date_created: model.date_created ? new Date(model.date_created) : null
        }))
        const payload = {
          models: models,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendAllRecentModels', payload)
        } else {
          context.commit('setAllRecentModels', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading all recent models:', error)
        context.commit('setAllRecentModelsLoading', false)
      })
  },
  loadAccessibleRecentModels (context, params = {}) {
    context.commit('setAccessibleRecentModelsLoading', true)
    const getAccessibleRecentModels = functions.httpsCallable('userMetrics-getUserAccessibleRecentModels')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getAccessibleRecentModels(requestParams)
      .then((result) => {
        const models = result.data.items.map(model => ({
          ...model,
          date_created: model.date_created ? new Date(model.date_created) : null
        }))
        const payload = {
          models: models,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendAccessibleRecentModels', payload)
        } else {
          context.commit('setAccessibleRecentModels', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading accessible recent models:', error)
        context.commit('setAccessibleRecentModelsLoading', false)
      })
  },
  loadUserCreatedModels (context, params = {}) {
    context.commit('setUserCreatedModelsLoading', true)
    const getUserCreatedModels = functions.httpsCallable('userMetrics-getUserCreatedModels')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getUserCreatedModels(requestParams)
      .then((result) => {
        const models = result.data.items.map(model => ({
          ...model,
          date_created: model.date_created ? new Date(model.date_created) : null
        }))
        const payload = {
          models: models,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendUserCreatedModels', payload)
        } else {
          context.commit('setUserCreatedModels', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading user created models:', error)
        context.commit('setUserCreatedModelsLoading', false)
      })
  },
  loadAllRecentUploads (context, params = {}) {
    context.commit('setAllRecentUploadsLoading', true)
    const getRecentUploads = functions.httpsCallable('userMetrics-getRecentUploads')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getRecentUploads(requestParams)
      .then((result) => {
        const uploads = result.data.items.map(upload => ({
          ...upload,
          dateUploaded: upload.dateUploaded ? new Date(upload.dateUploaded) : null,
          approvedDate: upload.approvedDate ? new Date(upload.approvedDate) : null,
          lastActivityDate: upload.lastActivityDate ? new Date(upload.lastActivityDate) : null
        }))
        const payload = {
          uploads: uploads,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendAllRecentUploads', payload)
        } else {
          context.commit('setAllRecentUploads', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading all recent uploads:', error)
        context.commit('setAllRecentUploadsLoading', false)
      })
  },
  loadUserRecentUploads (context, params = {}) {
    context.commit('setUserRecentUploadsLoading', true)
    const getUserRecentUploads = functions.httpsCallable('userMetrics-getUserRecentUploads')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getUserRecentUploads(requestParams)
      .then((result) => {
        const uploads = result.data.items.map(upload => ({
          ...upload,
          dateUploaded: upload.dateUploaded ? new Date(upload.dateUploaded) : null,
          approvedDate: upload.approvedDate ? new Date(upload.approvedDate) : null,
          lastActivityDate: upload.lastActivityDate ? new Date(upload.lastActivityDate) : null
        }))
        const payload = {
          uploads: uploads,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendUserRecentUploads', payload)
        } else {
          context.commit('setUserRecentUploads', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading user recent uploads:', error)
        context.commit('setUserRecentUploadsLoading', false)
      })
  },
  loadAllRecentStageActivity (context, params = {}) {
    context.commit('setAllRecentStageActivityLoading', true)
    const getRecentStageActivity = functions.httpsCallable('userMetrics-getRecentStageActivity')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getRecentStageActivity(requestParams)
      .then((result) => {
        const activities = result.data.items.map(activity => ({
          ...activity,
          activityDate: activity.activityDate ? new Date(activity.activityDate) : null
        }))
        const payload = {
          activities: activities,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendAllRecentStageActivity', payload)
        } else {
          context.commit('setAllRecentStageActivity', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading all recent stage activity:', error)
        context.commit('setAllRecentStageActivityLoading', false)
      })
  },
  loadUserRecentStageActivity (context, params = {}) {
    context.commit('setUserRecentStageActivityLoading', true)
    const getUserRecentStageActivity = functions.httpsCallable('userMetrics-getUserRecentStageActivity')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getUserRecentStageActivity(requestParams)
      .then((result) => {
        const activities = result.data.items.map(activity => ({
          ...activity,
          activityDate: activity.activityDate ? new Date(activity.activityDate) : null
        }))
        const payload = {
          activities: activities,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendUserRecentStageActivity', payload)
        } else {
          context.commit('setUserRecentStageActivity', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading user recent stage activity:', error)
        context.commit('setUserRecentStageActivityLoading', false)
      })
  },
  loadAccessibleRecentEkrms (context, params = {}) {
    context.commit('setAccessibleRecentEkrmsLoading', true)
    const getUserAccessibleRecentEkrms = functions.httpsCallable('userMetrics-getUserAccessibleRecentEkrms')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getUserAccessibleRecentEkrms(requestParams)
      .then((result) => {
        const ekrms = result.data.items.map(ekrm => ({
          ...ekrm,
          date_created: ekrm.date_created ? new Date(ekrm.date_created) : null
        }))
        const payload = {
          ekrms: ekrms,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendAccessibleRecentEkrms', payload)
        } else {
          context.commit('setAccessibleRecentEkrms', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading accessible recent EKRMs:', error)
        context.commit('setAccessibleRecentEkrmsLoading', false)
      })
  },
  loadUserCreatedEkrms (context, params = {}) {
    context.commit('setUserCreatedEkrmsLoading', true)
    const getUserCreatedEkrms = functions.httpsCallable('userMetrics-getUserCreatedEkrms')
    const requestParams = {
      limit: params.limit || 20,
      startAfter: params.startAfter || null
    }
    getUserCreatedEkrms(requestParams)
      .then((result) => {
        const ekrms = result.data.items.map(ekrm => ({
          ...ekrm,
          date_created: ekrm.date_created ? new Date(ekrm.date_created) : null
        }))
        const payload = {
          ekrms: ekrms,
          hasMore: result.data.hasMore,
          lastVisible: result.data.lastVisible
        }
        if (params.append) {
          context.commit('appendUserCreatedEkrms', payload)
        } else {
          context.commit('setUserCreatedEkrms', payload)
        }
      })
      .catch((error) => {
        console.error('Error loading user created EKRMs:', error)
        context.commit('setUserCreatedEkrmsLoading', false)
      })
  },
  setBasePrimaryColor (context, color) {
    context.commit('setBasePrimaryColor', color)
  },
  // Read by a Cloud Function, which also finds a model that has been moved to the trash.
  // Resolves { data, source ('model' or 'trash'), trash }.
  exportModelData (context, payload) {
    return functions.httpsCallable('supportExport-getExportData')({
      type: 'model',
      clientId: payload.clientId
    }).then(result => result.data)
  }
}

const mutations = {
  setBasePrimaryColor (state, color) {
    state.basePrimaryColor = color
  },
  setClientsInitialized (state, initialized) {
    state.clientsInitialized = initialized
  },
  setClients (state, payload) {
    state.clients = payload.clients.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  },
  setGroupClients (state, payload) {
    state.groupClients = payload.clients.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  },
  updateClients (state, payload) {
    state.clients.push(payload)
    state.clients = state.clients.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  },
  setCurrentClient (state, client) {
    let clientArray = []
    if (typeof client === 'object') {
      state.currentClient = client.code
      clientArray.push(client)
    } else {
      state.currentClient = client
      clientArray = state.clients.filter(item => {
        return item.id === client
      })
      if (clientArray.length === 0) {
        clientArray = state.groupClients.filter(item => {
          return item.id === client
        })
      }
    }
    if (clientArray.length > 0) {
      localStorage.currentClientId = state.currentClient
      const currentClientObject = {
        ...clientArray[0],
        colors: colors
      }
      var channelColors = {}
      var channels = {}

      if (currentClientObject.reference_model && currentClientObject.reference_model.config && 'media' in currentClientObject.reference_model.config) {
        const currentClientObjectConfig = currentClientObject.plan_reference_model ? currentClientObject.plan_reference_model.config : currentClientObject.reference_model.config
        Object.entries(currentClientObjectConfig.media).sort(([a], [b]) => a.localeCompare(b)).forEach((channel, index) => {
          channelColors[channel[0]] = colors[index]
          channels[channel[0]] = {
            name: channel[0]
          }
        })
        state.currentClientObject = {
          ...currentClientObject,
          channelColors: channelColors,
          channels: channels
        }
      } else {
        state.currentClientObject = currentClientObject
      }
    }
  },
  setCurrentClientDataFiles (state, payload) {
    state.currentClientDataFiles = payload.dataFiles
    state.currentClientDataFilesLoaded = payload.loaded !== false
  },
  setCurrentClientDataBriefs (state, payload) {
    state.currentClientDataBriefs = payload.dataBriefs
  },
  setCurrentClientStages (state, stages) {
    state.currentClientStages = stages
  },
  setCurrentClientStageFeedback (state, messages) {
    state.currentClientStageFeedback = messages
  },
  setUnsubscribeClients (state, unsubscribe) {
    state.unsubscribeClients = unsubscribe
  },
  setUnsubscribeGroupClients (state, unsubscribe) {
    state.unsubscribeGroupClients = unsubscribe
  },
  setUnsubscribeAllClients (state, unsubscribe) {
    state.unsubscribeAllClients = unsubscribe
  },
  setUnsubscribeClientStages (state, unsubscribe) {
    state.unsubscribeClientStages = unsubscribe
  },
  setUnsubscribeClientStageFeedback (state, unsubscribe) {
    state.unsubscribeClientStageFeedback = unsubscribe
  },
  setUnsubscribeClientDataFiles (state, unsubscribe) {
    state.unsubscribeClientDataFiles = unsubscribe
  },
  setUnsubscribeClientDataBriefs (state, unsubscribe) {
    state.unsubscribeClientDataBriefs = unsubscribe
  },
  setUnsubscribeClientsChunks (state, unsubscribeFunctions) {
    state.unsubscribeClientsChunks = unsubscribeFunctions
  },
  setRecentModels (state, payload) {
    state.recentModels = payload.models
    state.recentModelsHasMore = payload.hasMore || false
    state.recentModelsLastVisible = payload.lastVisible || null
    state.recentModelsLoading = false
  },
  appendRecentModels (state, payload) {
    state.recentModels = [...state.recentModels, ...payload.models]
    state.recentModelsHasMore = payload.hasMore || false
    state.recentModelsLastVisible = payload.lastVisible || null
    state.recentModelsLoading = false
  },
  setRecentModelsLoading (state, loading) {
    state.recentModelsLoading = loading
  },
  setAllRecentModels (state, payload) {
    state.allRecentModels = payload.models
    state.allRecentModelsHasMore = payload.hasMore || false
    state.allRecentModelsLastVisible = payload.lastVisible || null
    state.allRecentModelsLoading = false
  },
  appendAllRecentModels (state, payload) {
    state.allRecentModels = [...state.allRecentModels, ...payload.models]
    state.allRecentModelsHasMore = payload.hasMore || false
    state.allRecentModelsLastVisible = payload.lastVisible || null
    state.allRecentModelsLoading = false
  },
  setAllRecentModelsLoading (state, loading) {
    state.allRecentModelsLoading = loading
  },
  setAccessibleRecentModels (state, payload) {
    state.accessibleRecentModels = payload.models
    state.accessibleRecentModelsHasMore = payload.hasMore || false
    state.accessibleRecentModelsLastVisible = payload.lastVisible || null
    state.accessibleRecentModelsLoading = false
  },
  appendAccessibleRecentModels (state, payload) {
    state.accessibleRecentModels = [...state.accessibleRecentModels, ...payload.models]
    state.accessibleRecentModelsHasMore = payload.hasMore || false
    state.accessibleRecentModelsLastVisible = payload.lastVisible || null
    state.accessibleRecentModelsLoading = false
  },
  setAccessibleRecentModelsLoading (state, loading) {
    state.accessibleRecentModelsLoading = loading
  },
  setUserCreatedModels (state, payload) {
    state.userCreatedModels = payload.models
    state.userCreatedModelsHasMore = payload.hasMore || false
    state.userCreatedModelsLastVisible = payload.lastVisible || null
    state.userCreatedModelsLoading = false
  },
  appendUserCreatedModels (state, payload) {
    state.userCreatedModels = [...state.userCreatedModels, ...payload.models]
    state.userCreatedModelsHasMore = payload.hasMore || false
    state.userCreatedModelsLastVisible = payload.lastVisible || null
    state.userCreatedModelsLoading = false
  },
  setUserCreatedModelsLoading (state, loading) {
    state.userCreatedModelsLoading = loading
  },
  setAllRecentUploads (state, payload) {
    state.allRecentUploads = payload.uploads
    state.allRecentUploadsHasMore = payload.hasMore || false
    state.allRecentUploadsLastVisible = payload.lastVisible || null
    state.allRecentUploadsLoading = false
  },
  appendAllRecentUploads (state, payload) {
    state.allRecentUploads = [...state.allRecentUploads, ...payload.uploads]
    state.allRecentUploadsHasMore = payload.hasMore || false
    state.allRecentUploadsLastVisible = payload.lastVisible || null
    state.allRecentUploadsLoading = false
  },
  setAllRecentUploadsLoading (state, loading) {
    state.allRecentUploadsLoading = loading
  },
  setUserRecentUploads (state, payload) {
    state.userRecentUploads = payload.uploads
    state.userRecentUploadsHasMore = payload.hasMore || false
    state.userRecentUploadsLastVisible = payload.lastVisible || null
    state.userRecentUploadsLoading = false
  },
  appendUserRecentUploads (state, payload) {
    state.userRecentUploads = [...state.userRecentUploads, ...payload.uploads]
    state.userRecentUploadsHasMore = payload.hasMore || false
    state.userRecentUploadsLastVisible = payload.lastVisible || null
    state.userRecentUploadsLoading = false
  },
  setUserRecentUploadsLoading (state, loading) {
    state.userRecentUploadsLoading = loading
  },
  setAllRecentStageActivity (state, payload) {
    state.allRecentStageActivity = payload.activities
    state.allRecentStageActivityHasMore = payload.hasMore || false
    state.allRecentStageActivityLastVisible = payload.lastVisible || null
    state.allRecentStageActivityLoading = false
  },
  appendAllRecentStageActivity (state, payload) {
    state.allRecentStageActivity = [...state.allRecentStageActivity, ...payload.activities]
    state.allRecentStageActivityHasMore = payload.hasMore || false
    state.allRecentStageActivityLastVisible = payload.lastVisible || null
    state.allRecentStageActivityLoading = false
  },
  setAllRecentStageActivityLoading (state, loading) {
    state.allRecentStageActivityLoading = loading
  },
  setUserRecentStageActivity (state, payload) {
    state.userRecentStageActivity = payload.activities
    state.userRecentStageActivityHasMore = payload.hasMore || false
    state.userRecentStageActivityLastVisible = payload.lastVisible || null
    state.userRecentStageActivityLoading = false
  },
  appendUserRecentStageActivity (state, payload) {
    state.userRecentStageActivity = [...state.userRecentStageActivity, ...payload.activities]
    state.userRecentStageActivityHasMore = payload.hasMore || false
    state.userRecentStageActivityLastVisible = payload.lastVisible || null
    state.userRecentStageActivityLoading = false
  },
  setUserRecentStageActivityLoading (state, loading) {
    state.userRecentStageActivityLoading = loading
  },
  setAccessibleRecentEkrms (state, payload) {
    state.accessibleRecentEkrms = payload.ekrms
    state.accessibleRecentEkrmsHasMore = payload.hasMore || false
    state.accessibleRecentEkrmsLastVisible = payload.lastVisible || null
    state.accessibleRecentEkrmsLoading = false
  },
  appendAccessibleRecentEkrms (state, payload) {
    state.accessibleRecentEkrms = [...state.accessibleRecentEkrms, ...payload.ekrms]
    state.accessibleRecentEkrmsHasMore = payload.hasMore || false
    state.accessibleRecentEkrmsLastVisible = payload.lastVisible || null
    state.accessibleRecentEkrmsLoading = false
  },
  setAccessibleRecentEkrmsLoading (state, loading) {
    state.accessibleRecentEkrmsLoading = loading
  },
  setUserCreatedEkrms (state, payload) {
    state.userCreatedEkrms = payload.ekrms
    state.userCreatedEkrmsHasMore = payload.hasMore || false
    state.userCreatedEkrmsLastVisible = payload.lastVisible || null
    state.userCreatedEkrmsLoading = false
  },
  appendUserCreatedEkrms (state, payload) {
    state.userCreatedEkrms = [...state.userCreatedEkrms, ...payload.ekrms]
    state.userCreatedEkrmsHasMore = payload.hasMore || false
    state.userCreatedEkrmsLastVisible = payload.lastVisible || null
    state.userCreatedEkrmsLoading = false
  },
  setUserCreatedEkrmsLoading (state, loading) {
    state.userCreatedEkrmsLoading = loading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
